import * as _ from 'lodash';
import { tassign } from 'tassign';
import { createReducer, on } from '@ngrx/store';
import { clearPayformsFilterAction, removePayformsFilterStatusAction, setPayformsFilterDateAction, setPayformsFilterSicAction, setPayformsFilterStateAction } from './payforms-filter.actions';
import { AppStateUtils } from '../app-state.utils';
import { PayformsFilterDateTypes } from '../../enums/date-type.enum';
import { PayformsFilter } from '../../classes';

export const PayformsFilterReducer = createReducer(
  AppStateUtils.filterInitialState(),
  on(setPayformsFilterStateAction, (state, { filter }) => tassign(state, filter)),
  on(setPayformsFilterSicAction, (state, { sicCd }) => tassign(state, { sicCd })),
  on(setPayformsFilterDateAction, (state, { dateToSet, newDate }) => {
    switch (dateToSet) {
      case PayformsFilterDateTypes.fromDate:
        return tassign(state, {
          fromDate: newDate,
        });
      case PayformsFilterDateTypes.toDate:
        return tassign(state, {
          toDate: newDate,
        });
      default:
        return state;
    }
  }),
  on(removePayformsFilterStatusAction, (state, { status }) =>
    tassign(state, {
      status: state.status.filter(itemStatus => itemStatus !== status),
    })
  ),
  on(clearPayformsFilterAction, state => {
    const newState = new PayformsFilter();
    newState.sicCd = state.sicCd;
    return newState;
  })
);
